// External libraries
import React, { useEffect } from 'react';
import { AddIcon } from '@paypalcorp/pp-react-icons-weasley-v7';
import { ThemeProvider } from '@emotion/react';
import { PAYPAL_THEME } from '@paypalcorp/pp-react-theme-weasley-v7';

// Internal Modules
import { Button } from '@/components/Button';
// @ts-expect-error TODO untyped import
import { CRSTaxResidencyStatusRadioButtons } from '../CRSTaxResidencyStatusRadioButtons';
// @ts-expect-error TODO untyped import
import { CRSTaxDetails, InlineCRSTaxDetails } from './../CRSTaxDetails';
import { CRSLegalNames } from '../CRSLegalNames';
import {
  addNewTaxResidencyChangeHandler,
  createAccountHandler,
  // @ts-expect-error TODO untyped import
} from '../handlers';
import { CRSTaxDetailsContainer } from './StyledComponents';
// @ts-expect-error TODO untyped import
import { MarginSeparator, PlusLinkButton } from '../StyledComponents';
import { getContent, logger } from '@/lib';
import { ADD_TAX_DETAILS, PAYS_TAXES_OUTSIDE_COUNTRY } from './../constants';
// @ts-expect-error TODO untyped import
import { useCRSReducer } from '../hooks';
import { logAddingCrsTaxDetails } from './../fpti';
import { ParentContainer } from '../../Common';
import { useWindowSize } from '@/hooks';
import { PP_SECONDARY_COLOR } from '@/styles';
import { useStoreState } from '@/store';

export const InlineCRSForm = (): React.ReactElement => {
  useEffect(() => {
    logger.fpti('crs_form_rendered', {
      state_name: 'crs_section',
      transition_name: 'process_crs_form_rendered',
    });
    logger.info('crs_form_rendered');
  }, []);
  const crsTaxDetails = useStoreState(({ form }) => form.crsTaxDetails);
  const crsTaxDetailsLength = crsTaxDetails?.value?.length ?? 0;
  return (
    <>
      <div data-testid="crs-tax-collection-section">
        {crsTaxDetails?.value?.map((_, index) => {
          return (
            <>
              <InlineCRSTaxDetails
                crsTaxDetails={crsTaxDetails.value}
                index={index}
                key={`crs-tax-details-${index}`}
              />
            </>
          );
        })}
      </div>
      {crsTaxDetailsLength < 5 && (
        <ParentContainer margin="30px 0 0 0">
          <PlusLinkButton
            type="button"
            data-testid="crs-add-tax-country"
            onClick={() =>
              addNewTaxResidencyChangeHandler({
                crsTaxDetails: crsTaxDetails?.value,
              })
            }
          >
            <AddIcon size="sm" color={PP_SECONDARY_COLOR} />
            {getContent('crs.addCountry')}
          </PlusLinkButton>
        </ParentContainer>
      )}
    </>
  );
};

/** @deprecated CRSForm component as part of new inline implementation for CRS tax collection.
 * InlineCRSForm should be used instead.
 */
export const CRSForm = (): React.ReactElement => {
  const [state, dispatch] = useCRSReducer();
  const crsTaxDetailsIndexes = Object.keys(state.crsTaxDetails);
  const onClickButtonHandler = () =>
    createAccountHandler({
      dispatch,
      state,
    });
  const { isMobile } = useWindowSize();

  return (
    <>
      <CRSTaxDetailsContainer data-testid="crs-form">
        <CRSTaxResidencyStatusRadioButtons
          crsTaxStatus={state.crsTaxStatus}
          dispatch={dispatch}
        />
        {state?.crsTaxStatus?.value === PAYS_TAXES_OUTSIDE_COUNTRY && (
          <>
            {crsTaxDetailsIndexes.map(index => {
              return (
                <CRSTaxDetails
                  crsTaxDetails={state.crsTaxDetails}
                  dispatch={dispatch}
                  index={index}
                  key={index}
                />
              );
            })}
            <MarginSeparator />
            <PlusLinkButton
              data-testid="crs-add-tax-country"
              onClick={() => {
                logAddingCrsTaxDetails();
                dispatch({ type: ADD_TAX_DETAILS });
              }}
            >
              <ThemeProvider theme={PAYPAL_THEME}>
                <AddIcon size="sm" color={PP_SECONDARY_COLOR} />
              </ThemeProvider>
              {getContent('crs.addCountry')}
            </PlusLinkButton>
          </>
        )}
      </CRSTaxDetailsContainer>

      <CRSLegalNames
        crsLegalNames={{
          crsLegalFirstName: state.crsLegalFirstName,
          crsLegalLastName: state.crsLegalLastName,
        }}
        dispatch={dispatch}
      />
      <ParentContainer
        containerWidth={isMobile ? '100%' : '303px'}
        margin="32px auto"
      >
        <Button
          disabled={false}
          interstitial
          onClick={onClickButtonHandler}
          testID="crs-certify-create-btn"
          type="button"
        >
          {getContent('crs.certifyAndCreateAccount')}
        </Button>
      </ParentContainer>
    </>
  );
};
